import moment from "moment";
import ReactDatePicker from "react-datepicker";
import { Label } from "reactstrap";
import { CalenderIcon } from "../../Icon";
import Select from "react-select";
import { useState } from "react";
import { components } from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { NewDownloadIcon } from "../../../assets/images";
import {
  downloadClientWiseUserTimeSheetReportApi,
  downloadTimesheetSummaryReportApi,
} from "../../../apis/timeSheetApis";
import FileSaver from "file-saver";
import toast, { Toaster } from "react-hot-toast";
import { formatDate } from "../../../utils/commonFunctions";
import { TimesheetSummaryReportListType } from "../../../redux/timeSheet/timeSheetType";
import { GetTimeSheetSummaryReportDataPayloadType } from "../../../commonTypes/timeSheetTypes";
import { CircularAvatar } from "../../commons";

export type DropDownUserType = {
  value: number | null;
  label: string;
};

type AppProps = {
  startDate?: string;
  token: string | null;
  endDate?: string;
  type?: string;
  handleStartDateChange?: (date: string) => void;
  handleEndDateChange?: (date: string) => void;
  handleSubmitData?: () => void;
  setText: React.Dispatch<React.SetStateAction<string>>;
  setBranchText: React.Dispatch<React.SetStateAction<string>>;
  branchFetching: boolean;
  finalBranchDataList: any;
  setoffset: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  handleBranchDropDownChange: (data: any) => void;
  branch: DropDownUserType;
  showViewButton: boolean;
  handleUserWithNoTimesheet: () => void;
  downloadFinalData: any;
  timesheetSummaryReportList: any[] | [];
  currentStartDate: string;
  currentEndDate: string;
  finalClientList?: DropDownUserType[];
  client?: DropDownUserType;
  clientFetching?: boolean;
  setClient?: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  setClientOffset?: React.Dispatch<React.SetStateAction<number>>;
  setClientText?: React.Dispatch<React.SetStateAction<string>>;
};

const TimeSheetSummaryReportHeader = ({
  startDate,
  token,
  type,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  handleSubmitData,
  setText,
  setBranchText,
  branchFetching,
  clientFetching,
  finalBranchDataList,
  setoffset,
  limit,
  handleBranchDropDownChange,
  branch,
  showViewButton,
  handleUserWithNoTimesheet,
  timesheetSummaryReportList,
  downloadFinalData,
  currentStartDate,
  currentEndDate,
  finalClientList,
  client,
  setClient,
  setClientOffset,
  setClientText,
}: AppProps) => {
  const [loadCondition, setLoadCondition] = useState(true);

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setoffset((prv: any) => prv + limit);
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };

  const checkClientBottom = () => {
    setClientOffset && setClientOffset((prev: number) => prev + 20);
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const handlePrepareDownload = () => {
    let params: any = {
      start_date: currentStartDate,
      end_date: currentEndDate,
      client_code: client?.value,
      token,
    };

    if (params && token) {
      handleDownload(params);
    }
  };

  const handleDownload = (params: any) => {
    let reportName = type !== "clientWiseUserReport" ?
       "time_sheet_user_work_reports" +
        "_" +
        currentStartDate +
        "_" +
        currentEndDate +
        ".xlsx"
      : `client_wise_timesheet_reports(${client?.value})` + "_" +
      currentStartDate +
      "_" +
      currentEndDate +
      ".xlsx";
    let finalApi =
      type !== "clientWiseUserReport"
        ? downloadTimesheetSummaryReportApi(params)
        : downloadClientWiseUserTimeSheetReportApi(params);
    finalApi.then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };
  return (
    <>
      <div className="d-flex pt-3 pl-3 align-items-center">
        <div className="col-md-2 pr-0">
          <div className="form-group">
            <div className="date-picker-wraper mr-0">
              <Label className="m-0 p-0 w-100">
                From
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    startDate
                      ? new Date(
                          moment(`${startDate}T00:00:00`, "YYYY-MM-DD").format(
                            "YYYY-MM-DD[T]HH:mm:ss"
                          )
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    handleStartDateChange?.(moment(e).format("YYYY-MM-DD"));
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  placeholderText="Start Date"
                  className="form-control"
                />
                <span
                  className="calender-icon"
                  style={{ right: "8px", top: "26px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group">
            <div className="date-picker-wraper mr-0">
              <Label className="m-0 p-0 w-100">
                To
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    endDate
                      ? new Date(
                          moment(`${endDate}T00:00:00`, "YYYY-MM-DD").format(
                            "YYYY-MM-DD[T]HH:mm:ss"
                          )
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    handleEndDateChange?.(moment(e).format("YYYY-MM-DD"));
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  placeholderText="End Date"
                  className="form-control"
                />
                <span
                  className="calender-icon"
                  style={{ right: "20px", top: "26px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {type !== "clientWiseUserReport" ? (
          <div className="col-md-2 form-group d-flex flex-column p-0 pr-1">
            <label className="m-0 p-0" htmlFor="">
              Branch
            </label>
            <Select
              options={
                finalBranchDataList?.length
                  ? [
                      { value: null, label: "Select..." },
                      ...finalBranchDataList,
                    ]
                  : finalBranchDataList
              }
              value={branch}
              onChange={(e) => handleBranchDropDownChange(e)}
              isSearchable={true}
              isLoading={branchFetching}
              onMenuClose={onMenuClose}
              onMenuScrollToBottom={(e: any) => checkBottom(e)}
              onInputChange={(e: any) => {
                setLoadCondition(false);
                setBranchText(e);
                setoffset(0);
              }}
            />
          </div>
        ) : (
          <div className="col-md-3 p-0 pr-1" style={{ marginTop: "-18px" }}>
            <label htmlFor="employeeId">Client</label>
            <Select
              options={finalClientList}
              value={client}
              onChange={(value: any) => setClient && setClient(value)}
              isSearchable={true}
              components={{ Option }}
              isLoading={clientFetching}
              onMenuClose={() => setClientOffset?.(0)}
              onMenuScrollToBottom={checkClientBottom}
              onInputChange={(e) => {
                setClientText?.(e);
                setClientOffset?.(0);
              }}
            />
          </div>
        )}

        <div className="col-md-1">
          <button
            className="btn btn-primary mt-1 pt-2 pb-2"
            onClick={handleSubmitData}
            disabled={
              !startDate?.length ||
              !endDate?.length ||
              (type === "clientWiseUserReport" ? !client?.value : false)
            }
          >
            Apply
          </button>
        </div>
        {type !== "clientWiseUserReport" ? <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {
            <div className="ml-3 pr-2">
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 250 }}
                overlay={
                  <Tooltip id="button-view-download-invoice">
                    Download Reports
                  </Tooltip>
                }
              >
                <button
                  className="btn form-control mt-1"
                  style={{ border: "1px solid #bfcbe1" }}
                  onClick={() => handlePrepareDownload()}
                  disabled={!timesheetSummaryReportList?.length}
                >
                  <img src={NewDownloadIcon} alt="download icon" />
                </button>
              </OverlayTrigger>
            </div>
          }
          <div className="col-md-10">
            {showViewButton && type !== "clientWiseUserReport" && (
              <span
                style={{
                  display: "flex",
                  color: "#7c8db0",
                  fontSize: "14px",
                  float: "right",
                }}
              >
                <div style={{ minWidth: "300px" }}>
                  <button
                    onClick={handleUserWithNoTimesheet}
                    style={{
                      padding: "6px 18px",
                      color: "#dd4433",
                      background: "#fff",
                      fontSize: "16px",
                      border: "1px solid #bfcbe1",
                      borderRadius: "4px",
                    }}
                  >
                    View Missing Timesheet Report
                  </button>
                </div>
              </span>
            )}
          </div>
        </div>:null}
        <Toaster />
      </div>
    </>
  );
};

export default TimeSheetSummaryReportHeader;
